import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {
    ConsentFormDto,
    PerFormaAPIService,
    UserConsentRequest,
    UserConsentResponse
} from "src/app/services/pfapi.service";
import {lastValueFrom} from "rxjs";
import {DomSanitizer} from "@angular/platform-browser";
import {NzMessageService} from "ng-zorro-antd/message";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
    selector: "app-consent",
    templateUrl: "./consent.component.html",
    styleUrl: "./consent.component.scss",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConsentComponent implements OnInit {
    constructor(
        private api: PerFormaAPIService,
        private sanitizer: DomSanitizer,
        private router: Router,
        private route: ActivatedRoute,
        private message: NzMessageService
    ) {}

    loading = true;
    returnUrl: string | null = null;
    formID = 0;
    forms: ConsentFormDto[] = [];
    logoutOnDecline = false;
    formTemplate: any;
    agree = false;
    disagree = false;
    agreeMessage = "I have read and agree to this";
    disagreeMessage = "I DO NOT agree to this";
    okMessage = "Submit";
    logoutMessage = "Logout";

    async ngOnInit() {
        try {
            const url = this.route.snapshot.queryParamMap.get("return");
            if (url && url.length > 0) this.returnUrl = url;

            this.forms = (await lastValueFrom(this.api.getApiConsentForms())) || [];

            await this.loadFirstForm();
        } catch (error: any) {
            console.log(error);
        } finally {
            this.loading = false;
        }
    }

    async loadFirstForm() {
        await this.resetValues();

        // no forms left -> they're done; send them on their way
        if (!this.forms || this.forms.length == 0) {
            this.router.navigateByUrl(this.returnUrl ? this.returnUrl : "/search");
            return;
        }

        const form = this.forms[0];
        this.formID = form.FormID!;
        this.formTemplate = this.sanitizer.bypassSecurityTrustHtml(form.TemplateHTML ?? "");
        this.logoutOnDecline = form.LogoutOnDecline ?? false;
    }

    async resetValues() {
        this.agree = false;
        this.disagree = false;
        this.formTemplate = "";
    }

    async save() {
        this.loading = true;

        // the form currently being answered (used for the AI-consent special case)
        const formName = (this.forms.find(x => x.FormID == this.formID)?.Name ?? "").toLowerCase();

        const answer = {
            FormID: this.formID,
            Accepted: this.agree
        } as UserConsentRequest;

        await lastValueFrom(this.api.postApiConsentAnswer(answer))
            .then(async (resp: UserConsentResponse) => {
                // a required form was declined -> log out (no server-side /account/logout route in the SPA)
                if (resp.Logout) {
                    localStorage.removeItem("pf_token");
                    this.router.navigateByUrl("/account/login");
                    return;
                }

                // AI consent flows back to the AI settings page
                if (formName == "aiconsent") {
                    this.router.navigateByUrl("/configure/aisetting");
                    return;
                }

                this.forms = (resp.Forms as ConsentFormDto[]) ?? [];
                await this.loadFirstForm();
            })
            .catch((error: any) => {
                console.log(error);
                this.message.error("something went wrong");
            })
            .finally(() => {
                this.loading = false;
            });
    }
}
